export default __webpack_public_path__ + "static/media/ABChanelCorpo-ExtraLight.fbbed646.woff";